import * as React from 'react';
import TranslationView from '../../../../components/Translation/TranslationView';
import SharedViewProps from '../../../../../models/types/SharedViewProps';
import ConfirmationViewStyle from './ConfirmationViewStyle';

const ConfirmationView = (props: SharedViewProps) => {

    const style = new ConfirmationViewStyle();

    return (
        <div style={style.shellContainer}>
            <div style={style.container}>

                {/* BOX CONTENT */}
                <div style={style.box}>

                    {/* BOX HEADER */}
                    <div style={style.boxHeader}>
                        <div style={style.boxHeaderTitle}>
                            <TranslationView>
                                requestConfirmation
                      </TranslationView>
                        </div>
                        <div style={style.boxHeaderBody}>
                            <TranslationView>
                                thanksConfirmation
                      </TranslationView>
                        </div>
                    </div>

                    {/* BOX FOOTER */}
                    <div style={style.boxFooter}>
                        <TranslationView>
                            youWillReceiveEmail
                    </TranslationView>
                    </div>
                </div>
                <img style={style.image} src={require('./assets/small_logo.png')} />
            </div>
            <span onClick={() => props.routeProps.history.push('introduction')} style={style.backToHome}>
                <TranslationView>
                    backToHome
                </TranslationView>
            </span>
        </div>
    )
};

export default ConfirmationView;